<template>
  <div id="order_signup">
    <dd-header
    />
    <div class="wrapper">
      <dd-sitemap
        :pageKey="pageKey"
        :pageList="pageList"
        v-if="isOrder"
      />
      <div id="order_signup_content">
        <section>
          <div>ログイン</div>
          <div>
            <dd-login
              :routeType="routeType"
            />
          </div>
        </section>
        <section>
          <div>はじめての方・会員登録されていない方</div>
          <div id="member_merit">
            <div class="title">会員登録するとこんなにお得！</div>
            <ul>
              <li>
                会員限定価格での商品購入
              </li>
              <li>
                メールマガジンでお得な情報をお届け
              </li>
              <li>
                ご注文時の情報入力がスムーズに
              </li>
            </ul>
            <div class="detail_btn" @click="signup">会員登録はこちら 〉〉</div>
            <div class="explanation">※法人会員の申請の場合、審査にお時間をいただきます。</div>
            <div class="detail_btn2" @click="order" v-if="isOrder">注文へ進む 〉〉</div>
            <div class="explanation" v-if="isOrder">※会員登録なしでもお買い物が可能です。</div>
          </div>
        </section>
      </div>
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
    <!-- <dd-image-viewer-model /> -->
  </div>
</template>
<script>
// import axios from 'axios'

import Header from '../components/common/DcHeader'
import Footer from '../components/common/DcFooter'
import LoginForm from '../components/login/DcLoginForm'
import DcSiteMap from '../components/common/DcSiteMap'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  name: 'DcOrderSignIn',
  components: {
    'dd-header': Header,
    'dd-footer': Footer,
    'dd-login': LoginForm,
    'dd-sitemap': DcSiteMap,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      pageKey: 'dcOrderSignIn',
      pageList: [
        {id: 'orderSignUp', key: 'dcOrderSignIn', title: 'ログイン'},
        {id: 'paymentSelect', key: 'dcPaymentSelect', title: '決済方法選択'},
        {id: 'orderInput', key: 'dcOrderInput', title: '納品先入力'},
        {id: 'constructInput', key: 'dcConstructInput', title: '組立設置情報入力'},
        {id: 'orderConfirm', key: 'dcOrderConfirm', title: 'ご注文内容確認'},
        {id: 'orderComplete', key: 'dcOrderComplete', title: '注文完了'}
      ],
      type: ''
    }
  },
  computed: {
    routeType: function () {
      if (this.type === 'order') {
        return 1
      } else if (this.type === 'sketch') {
        return 2
      }
      return 0
    },
    isOrder: function () {
      if (this.type === 'order') {
        return true
      }
      return false
    }
  },
  methods: {
    goBack: function () {
      this.$router.go(-1)
    },
    signup: function () {
      this.$router.push({
        name: 'DcSignUp'
      })
    },
    order: function () {
      this.$router.push({
        name: 'DcPaymentSelect'
      })
    }
  },
  created () {
    this.type = this.$route.params.type
  }
}
</script>
<style src="../css/dc-login.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcOrderSignIn.vue